<template>
  <div class="form-block">
    <div class="container-fluid">

      <div class="soh-list-view">
        <div class="row" v-for="(boiler, index) in boilers" :key="index">
          <div class="col-12">
            <h2>Wybierz klasę kotła na paliwo stałe</h2>
          </div>

          <div class="col-xs-12 col-md-6">
            <InputDropdown
              :is-small="true"
              placeholder="Klasa kotła/kotłów"
              :items="boilerClasses"
              v-model="boiler.boilerClass"
              :error="errors.boilers && errors.boilers[index] && errors.boilers[index].boilerClass"
            />
          </div>

          <div class="col-xs-12 col-md-5" style="margin-right: -2.5rem">
            <label>
              <input
                class="text-input w-small"
                type="text"
                style="margin: .5rem .5rem .5rem 0;"
                v-model="boiler.count"
                :class="{error: errors.boilers && errors.boilers[index] && errors.boilers[index].count}"
              />
              Liczba kotłów w wybranej klasie
            </label>
          </div>

          <div class="col-xs-12 col-md-1">
            <button type="button" class="btn btn-link" @click="removeBoiler(index)" style="height: 100%">
              Usuń
            </button>
          </div>

          <div class="col-12">
            <hr/>
          </div>

        </div>

        <div class="col-12">
          <a href="#" @click="addEmptyBoiler">
            <ZoneIcon icon-name="Plus"/>
            <label>Dodaj kolejną klasę kotła/kotłów</label>
          </a>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import InputDropdown from "@/components/common/InputDropdown";
import ZoneIcon from "@/components/common/ZoneIcon";
import DeclarationModel from "@/models/declarations";
import Common from "@/components/declarations/validators/Common";


export default {
  name: "BoilersClassesScreen",
  mixins: [Common],
  components: {InputDropdown, ZoneIcon},
  data() {
    return {
      boilers: [],
      boilerClasses: []
    }
  },
  methods: {
    setData(data) {
      if (!data.boiler_classes_count.length) {
        return;
      }
      this.boilers = data.boiler_classes_count.map((boiler) => {
        return {
          boilerClass: boiler.boiler_class,
          count: boiler.count
        };
      });
    },
    emitChange() {
      this.$emit('update', {
        boilerClassesCount: this.boilers
      });
    },
    getBoilerClasses() {
      DeclarationModel.getBoilerClasses()
        .then((res) => this.boilerClasses = res.data);
    },
    removeBoiler(index) {
      this.boilers.splice(index, 1);
    },
    addEmptyBoiler() {
      const data = {
        boilerClass: {},
        count: null
      }
      this.boilers.push(data);
    }
  },
  mounted() {
    this.getBoilerClasses();
  }
}
</script>

<style scoped>
input[type=text] {
  height: 2rem;
}

hr {
  border: 0;
  border-top: 2px solid #dadada;
  margin: 1rem -2.45rem;
}

h1 {
  font-size: 1.3rem;
}

h2 {
  font-size: 1.2rem;
  font-family: "Volte Semibold", serif;
  color: #6f6f6f;
}

a, a label {
  color: #000000;
  cursor: pointer;
}

a label {
  padding: 0 1rem;
  font-family: "Volte Semibold", serif;
  color: #6e7182;
  cursor: pointer;
}

.soh-list-view {
  height: 29rem;
  min-height: 25rem;
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;
}

@media screen and (max-width: 768px) {

  .soh-list-view {
    height: auto;
    min-height: 10rem;
    overflow-y: hidden;
    width: 100%;
  }
}
</style>
